import request from '@/utils/request'

// main screen
export function getListTxnWithSubTxn(query) {
  return request({
    url: '/config-service/v1/transaction/transaction/list-with-sub-transaction',
    method: 'get',
    params: query
  })
}

export function getTxn(query) {
  return request({
    url: '/config-service/v1/assign-business-district/transactions',
    method: 'get',
    params: query
  })
}

export function getBusinessDistrictByTxn(query) {
  return request({
    url: '/config-service/v1/assign-business-district/transaction-business',
    method: 'get',
    params: query
  })
}

// dialog 1
export function getBusinessDistrictWithDefaultTxn(query) {
  return request({
    url: '/config-service/v1/business-district/business-default-transaction',
    method: 'get',
    params: query
  })
}

export function assignDefaultTxn(data) {
  return request({
    url: '/config-service/v1/assign-business-district/default-assign',
    method: 'post',
    data
  })
}

// dialog 2
export function getBusinessShift(query) {
  return request({
    url: '/config-service/v1/assign-business-district/business-shift',
    method: 'get',
    params: query
  })
}

export function assignRoom(data) {
  return request({
    url: '/config-service/v1/assign-business-district/room-assign',
    method: 'post',
    data
  })
}

// dialog 3
export function getBusinessProductAssign(query) {
  return request({
    url: '/config-service/v1/assign-business-district/business-product-assign',
    method: 'get',
    params: query
  })
}

export function getMenuByBusinessDistrict(query) {
  return request({
    url: '/config-service/v1/business-district-menu/list-by-business-district',
    method: 'get',
    params: query
  })
}

// tree data
export function getProductCategory() {
  return request({
    url: '/config-service/v1/product-portfolio/list-non-paging',
    method: 'get'
  })
}

// has pagination
// call after watch change business district (and shift) or click search (search btn only enable only after business is chosen)
export function getAvailableProducts(query) {
  return request({
    url: '/config-service/v1/assign-business-district/available-products',
    method: 'get',
    params: query
  })
}

// call after watch change business district (and shift) or click search (search btn only enable only after business is chosen)
export function getAssignedProducts(query) {
  return request({
    url: '/config-service/v1/assign-business-district/assigned-products',
    method: 'get',
    params: query
  })
}

export function assignProduct(data) {
  return request({
    url: '/config-service/v1/assign-business-district/product-assign',
    method: 'post',
    data
  })
}

// delete api
